import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import { paginationData } from "../../utilities/functions";
import { nameSearch } from "../name_search";

// integations for
// model
// "crm.tag"
// "res.partner"

const getContextArgs = (model, context) => {
  const contextArgs = {
    "res.partner": {
      res_partner_search_mode: "customer",
      default_name: false,
      default_street: false,
      default_is_company: true,
      default_company_name: false,
      default_street2: false,
      default_city: false,
      default_title: false,
      default_state_id: false,
      default_zip: false,
      default_country_id: false,
      default_function: false,
      default_phone: false,
      default_mobile: false,
      default_email: false,
      default_user_id: context.uid,
      default_team_id: 1,
      default_website: false,
      show_vat: true,
    },
    "crm.tags": {},
  };
  return contextArgs[model];
};
export const nameSearchCRM = async ({
  model,
  context,
  company_id,
  pagination = { limit: PAGINATION_DEFAULT_LIMIT },
  name = "",
  args = [],
}) => {
  const myArgs = getContextArgs(model, context);
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [],
      model: model,
      fields: [],
      method: "name_search",
      kwargs: {
        name,
        args,
        operator: "ilike",
        ...paginationData(pagination),

        context: {
          lang: context.lang,
          tz: context.tz,
          uid: context.uid,
          allowed_company_ids: [company_id],

          ...myArgs,
        },
      },
    },
  });
  return nameSearch(raw, model);
};
